import styled from 'styled-components';

const Footer = styled.footer`
  position: relative;
  z-index: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.85rem;
  padding: 28px 16px 40px;

  a {
    color: #d7c4ff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

function SiteFooter() {
  return (
    <Footer>
      <a href="/privacy">Privacy</a>
    </Footer>
  );
}

export default SiteFooter;
